import React from "react";
import { Modal, Box, Typography, Button } from "@mui/material";
import close from "../../assets/icons/close.png";

const PlanUpgradeModal = ({
  open,
  onClose,
  onUpgrade,
  featureName = "This feature",
}) => {
  const brandColor = "#371b17";

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="plan-upgrade-modal-title"
      aria-describedby="plan-upgrade-modal-description"
    >
      <Box
        className="modal-wrapper" // Reusing existing CSS class if available
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90%", sm: 400 },
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 3,
          outline: "none",
          border: `2px solid ${brandColor}`, // Brand color border
        }}
      >
        {/* Header */}
        <Typography
          id="plan-upgrade-modal-title"
          variant="h6"
          component="h2"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
            color: brandColor,
            fontWeight: 600,
          }}
        >
          <span>Upgrade Required</span>
          <Box
            component="img"
            src={close}
            alt="close"
            onClick={onClose}
            sx={{
              width: "1.2rem",
              cursor: "pointer",
              "&:hover": { opacity: 0.7 },
            }}
          />
        </Typography>

        {/* Body Message */}
        <Typography
          id="plan-upgrade-modal-description"
          sx={{ mb: 3, color: "text.secondary", lineHeight: 1.6 }}
        >
          <strong>{featureName}</strong> is available only on Premium plans.
          Upgrade now to unlock this feature.
        </Typography>

        {/* Action Buttons */}
        <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end" }}>
          <Button
            onClick={onClose}
            variant="outlined"
            sx={{
              color: brandColor,
              borderColor: brandColor,
              "&:hover": {
                borderColor: brandColor,
                bgcolor: "rgba(55, 27, 23, 0.04)",
              },
            }}
          >
            Maybe Later
          </Button>
          <Button
            onClick={onUpgrade}
            variant="contained"
            sx={{
              bgcolor: brandColor,
              "&:hover": { bgcolor: "#2a1512" },
              px: 3,
            }}
          >
            View Plans
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default PlanUpgradeModal;
